import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const search = () => {
    const kw = keyword.trim();
    if (kw) navigate(`/category?q=${encodeURIComponent(kw)}`);
    else navigate('/category');
  };

  return (
    <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=vibrant%20stylized%20anime%20cityscape%20at%20golden%20sunset%20with%20silhouetted%20characters%20and%20floating%20magical%20sparkles%2C%20coral%20magenta%20and%20warm%20amber%20color%20palette%2C%20artistic%20abstract%20clean%20vector%20illustration%2C%20energetic%20dynamic%20composition%2C%20cinematic%20wide%20banner&width=1600&height=900&seq=hero-bg-anime&orientation=landscape"
        alt="动漫网二次元世界背景"
        title="动漫网 - 二次元快乐入口"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/60" />

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm">
          <i className="ri-fire-fill text-secondary-300" aria-hidden="true" />
          全网最全动漫网址收藏与直达导航
        </span>
        <h1 className="mt-5 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          动漫网官网<span className="text-secondary-300">首页直达</span>
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-base text-background-100/90 md:text-lg">
          收藏这个动漫网导航页，就等于把动漫网入口地址握在手里。网址收藏、直达链接、主页导航全都有，想看番直接进，不用再搜来搜去。
        </p>

        <div className="mx-auto mt-8 flex max-w-xl items-center gap-2 rounded-full bg-background-50 p-1.5 shadow-sm">
          <i className="ri-search-line pl-3 text-lg text-foreground-400" aria-hidden="true" />
          <input
            type="search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && search()}
            placeholder="搜索想看的动漫、番剧"
            aria-label="搜索动漫"
            className="w-full bg-transparent py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
          />
          <button
            type="button"
            onClick={search}
            className="flex items-center gap-1.5 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-search-line" aria-hidden="true" />搜索
          </button>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/category"
            className="flex items-center gap-1.5 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-play-circle-fill" aria-hidden="true" />立即看番
          </Link>
          <Link
            to="/about"
            className="flex items-center gap-1.5 rounded-full bg-background-50/20 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm hover:bg-background-50/30 transition-colors whitespace-nowrap"
          >
            <i className="ri-bookmark-line" aria-hidden="true" />收藏本站
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 gap-4 md:gap-6">
        {[
          { num: '560+', label: '精选番剧' },
          { num: '6', label: '热门分类' },
          { num: '120万+', label: '累计访问' },
        ].map((s) => (
          <div key={s.label} className="text-center">
            <p className="font-heading text-xl text-secondary-300 md:text-2xl">{s.num}</p>
            <p className="text-xs text-background-100/80">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}